const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

// Indian number formatting function
export function formatIndianNumber(num, decimalPlaces = 2) {
  if (isNaN(num) || num === null || num === undefined) return '0';
  
  const number = Number(num);
  const isNegative = number < 0;
  const absNumber = Math.abs(number);
  
  // Format with specified decimal places
  const formattedNumber = absNumber.toFixed(decimalPlaces);
  const [integerPart, decimalPart] = formattedNumber.split('.');
  
  // Apply Indian number system formatting
  let result = '';
  const length = integerPart.length;
  
  if (length <= 3) {
    result = integerPart;
  } else if (length <= 5) {
    // Format as X,XXX or XX,XXX
    result = integerPart.slice(0, length - 3) + ',' + integerPart.slice(length - 3);
  } else if (length <= 7) {
    // Format as X,XX,XXX or XX,XX,XXX
    result = integerPart.slice(0, length - 5) + ',' + 
             integerPart.slice(length - 5, length - 3) + ',' + 
             integerPart.slice(length - 3);
  } else {
    // Format for crores and above: X,XX,XX,XXX
    const croreLength = length - 7;
    result = integerPart.slice(0, croreLength) + ',' +
             integerPart.slice(croreLength, croreLength + 2) + ',' +
             integerPart.slice(croreLength + 2, croreLength + 4) + ',' +
             integerPart.slice(croreLength + 4);
  }
  
  // Add decimal part if it exists and is not zero
  if (decimalPart && parseInt(decimalPart) !== 0) {
    result += '.' + decimalPart;
  }
  
  return (isNegative ? '-' : '') + result;
}

// Convenience function for currency formatting
export function formatIndianCurrency(num, decimalPlaces = 2) {
  return '₹' + formatIndianNumber(num, decimalPlaces);
}

function convertLessThanOneThousand(num) {
  if (num === 0) return '';

  if (num < 10) return ones[num];
  
  if (num < 20) return teens[num - 10];
  
  if (num < 100) {
    return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? ' ' + ones[num % 10] : '');
  }
  
  if (num < 1000) {
    return ones[Math.floor(num / 100)] + ' Hundred' + (num % 100 !== 0 ? ' and ' + convertLessThanOneThousand(num % 100) : '');
  }
}

export function numberToWords(num) {
  if (num === 0) return 'Zero';
  
  const numStr = Math.floor(num).toString();
  const decimalPart = (num % 1).toFixed(2).substring(2);
  
  let words = '';
  
  if (numStr.length <= 3) {
    words = convertLessThanOneThousand(parseInt(numStr));
  } else if (numStr.length <= 5) {
    const thousands = parseInt(numStr.substring(0, numStr.length - 3));
    const hundreds = parseInt(numStr.substring(numStr.length - 3));
    
    words = convertLessThanOneThousand(thousands) + ' Thousand';
    if (hundreds !== 0) {
      words += ' ' + convertLessThanOneThousand(hundreds);
    }
  } else if (numStr.length <= 7) {
    const lakhs = parseInt(numStr.substring(0, numStr.length - 5));
    const thousands = parseInt(numStr.substring(numStr.length - 5, numStr.length - 3));
    const hundreds = parseInt(numStr.substring(numStr.length - 3));
    
    words = convertLessThanOneThousand(lakhs) + ' Lakh';
    if (thousands !== 0) {
      words += ' ' + convertLessThanOneThousand(thousands) + ' Thousand';
    }
    if (hundreds !== 0) {
      words += ' ' + convertLessThanOneThousand(hundreds);
    }
  } else {
    const crores = parseInt(numStr.substring(0, numStr.length - 7));
    const lakhs = parseInt(numStr.substring(numStr.length - 7, numStr.length - 5));
    const thousands = parseInt(numStr.substring(numStr.length - 5, numStr.length - 3));
    const hundreds = parseInt(numStr.substring(numStr.length - 3));
    
    words = convertLessThanOneThousand(crores) + ' Crore';
    if (lakhs !== 0) {
      words += ' ' + convertLessThanOneThousand(lakhs) + ' Lakh';
    }
    if (thousands !== 0) {
      words += ' ' + convertLessThanOneThousand(thousands) + ' Thousand';
    }
    if (hundreds !== 0) {
      words += ' ' + convertLessThanOneThousand(hundreds);
    }
  }
  
  words += ' Rupees';
  
  if (decimalPart !== '00') {
    const paise = parseInt(decimalPart);
    if (paise !== 0) {
      words += ' and ' + convertLessThanOneThousand(paise) + ' Paise';
    }
  }
  
  return words + ' Only';
} 